import { KINDS, splitChips } from '../lib/verdict';
import { cn, qty } from '../lib/utils';

/** dest === undefined: still computing. dest === null: unavailable. */
export default function DestinationChips({ dest, className }) {
  if (dest === undefined) {
    return (
      <span className={cn('inline-flex gap-1', className)}>
        <span className="skeleton h-5 w-14" />
      </span>
    );
  }
  const chips = splitChips(dest);
  if (!chips.length) return null;
  return (
    <span className={cn('inline-flex flex-wrap gap-1', className)}>
      {chips.map((c) => (
        <span
          key={c.kind}
          className={cn(KINDS[c.kind].tone, 'inline-flex items-center gap-1 rounded-md bg-tone-bg px-1.5 py-0.5 text-[12px] font-bold leading-4 text-tone')}
        >
          <span className="h-1.5 w-1.5 rounded-full bg-tone" />
          {KINDS[c.kind].word}
          <span className="font-semibold opacity-80">{qty(c.qty)}</span>
        </span>
      ))}
    </span>
  );
}
